import { __awaiter } from "tslib";
import { LocationService } from "@/services/models/schedule/location";
const moduleLocation = {
    namespaced: true,
    state: {
        location: [],
        loading: false,
        selected_location_id: 0,
    },
    getters: {
        getLocation: (state) => state.location,
        getLoading: (state) => state.loading,
    },
    mutations: {
        setLocation: (state, location) => (state.location = location),
        setLoading: (state, loading) => (state.loading = loading),
    },
    actions: {
        loadLocationByNodeId({ commit }, id) {
            return __awaiter(this, void 0, void 0, function* () {
                commit("setLoading", true);
                const LOCATION = yield LocationService.findByNodeId(id);
                commit("setLocation", LOCATION);
                commit("setLoading", false);
            });
        },
    },
};
export default moduleLocation;
